
import { defineComponent } from "vue";
import MessageNotificationList from "@/components/MessageNotificationList.vue";
import Navbar, { NavbarItem } from "../../components/Navbar.vue";
import store from "@/store";
import { RoleId } from "@/entities";
import FloatingMessage from "@/components/FloatingMessage.vue";
import {imageUploadService} from "@/services";
export default defineComponent({
  name: "PublicLayout",
  data() {
    return {
      navbarItems: [
        {
          title: "INICIO",
          to: { name: "home" },
        },
        {
          title: "NOTICIAS",
          to: { name: "public-news" },
        },
        {
          title: "VIDEOS",
          to: { name: "public-videos" },
        },
        {
          title: "INFORME MENSUAL",
          to: { name: "public-reports" },
        },
        {
          title: "CERTIFICACIÓN",
          to: { name: "public-certification" },
        },
        {
          title: "SOLICITUD DE INFORMACIÓN",
          to: { name: "public-registration" },
        },
        {
          title: "INICIAR SESIÓN",
          to: { name: "login" },
        },
      ] as NavbarItem[],
      negative_image: null,
      isLoading: false
    };
  },
  async beforeMount() {
    try {
      await this.$store.dispatch("authUser/getAuthUser");
      this.dynamicRoute();
    } catch (error) {
      //No user logged
      console.log("Error loading user. Try again!");
    }
  },
  async mounted() {
    await this.getLogo()

    const currRouteName = this.$router.currentRoute.value.name;
    if (typeof currRouteName !== "symbol") {
      this.updateActiveRoute(currRouteName);
    }
  },
  beforeRouteUpdate(to, _from, next) {
    const currRouteName = to.name;
    if (typeof currRouteName !== "symbol") {
      this.updateActiveRoute(currRouteName);
    }
    next();
  },
  methods: {
    updateActiveRoute(activeRouteName: null | string | undefined) {
      for (const item of this.navbarItems) {
        if (
          activeRouteName &&
          typeof item.to !== "string" &&
          item.to.name === activeRouteName
        ) {
          item.isActive = true;
        } else {
          item.isActive = false;
        }
      }
    },
    dynamicRoute() {
      if (this.userId != null || this.userId != undefined) {
        //remove register and login
        const newNavbarItems = this.navbarItems.filter((item) => {
          //remove register
          if (item.title == "SOLICITUD DE INFORMACIÓN") {
            return;
          }
          //remove login
          if (item.title == "INICIAR SESIÓN") {
            return;
          }
          return item;
        });

        // add request link or admin

        if (this.userId == RoleId.Citizen) {
          newNavbarItems.push({
            title: "SOLICITUD DE INFORMACIÓN",
            to: { name: "citizen-dashboard" },
          });
        } else {
          //admins and entity editor
          newNavbarItems.push({
            title: "ADMINISTRACIÓN",
            to: { name: "admin-dashboard" },
          });
        }

        this.navbarItems = newNavbarItems;
      }
    },
    async getLogo(){
      this.isLoading = true
      try {
        const response = await imageUploadService.getLogos();
        this.negative_image = response.data.negative_image.logo_image.image.url
        this.isLoading = false
      } catch (error) {
        console.error("Error al obtener los datos públicos:", error);
        this.isLoading = false
      }
    }
  },
  computed: {
    userId() {
      return store.state.authUser?.user?.roleId ?? null;
    },
  },
  components: {FloatingMessage, Navbar, MessageNotificationList },
});
